import React from 'react'
import { Tooltip, Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import "./../App.css";

const Skills = (props) => {
    const mediaMatch = useMediaQuery('(min-width:680px)');
    const bigSize = useMediaQuery('(min-width:1200px)');
    return (
        <div style={{display:'flex',flexDirection:'column', gap:'10px', padding:'5%'}}>
            <Typography sx={{fontSize:'24px',textAlign:'center',marginBottom:3}}>SKILLS</Typography>
            <div style={{display:mediaMatch?'flex':"block",justifyContent:'center',gap:'5%'}}>
                <div style={{
                    display:'grid',
                    gridTemplateColumns:bigSize?'repeat(6,1fr)': mediaMatch ? 'repeat(5,1fr)':'repeat(3,1fr)',
                    gap:bigSize ? '7.4em': mediaMatch ? "4.4em" : "3.4em",
                    className:"skill-container"
                }}>
                    <Tooltip title='react'><img className='img-scale' alt="" src="https://icongr.am/devicon/react-original.svg?size=128&color=currentColor" width='50px'/></Tooltip>
                    <Tooltip title='npm'><img className='img-scale' alt="" src="https://icongr.am/devicon/npm-original-wordmark.svg?size=128&color=currentColor" width='50px'/></Tooltip>
                    <Tooltip title='nodejs'><img className='img-scale' alt="" src="https://icongr.am/devicon/nodejs-original.svg?size=128&color=currentColor" width='50px'/></Tooltip>
                    <Tooltip title='mongodb'><img className='img-scale' alt="" src="https://icongr.am/devicon/mongodb-original.svg?size=128&color=currentColor" width='50px'/></Tooltip>
                    <Tooltip title='javascript'><img className='img-scale' alt="" src="https://icongr.am/devicon/javascript-original.svg?size=128&color=currentColor" width='50px'/></Tooltip>
                    <Tooltip title='google'><img className='img-scale' alt="" src="https://icongr.am/devicon/google-original.svg?size=128&color=currentColor" width='50px'/></Tooltip>
                    <Tooltip title='github'><img className='img-scale' alt="" src="https://icongr.am/devicon/github-original.svg?size=128&color=currentColor" width='50px'/></Tooltip>
                    <Tooltip title='express'><img className='img-scale' alt="" src="https://icongr.am/devicon/express-original.svg?size=128&color=currentColor" width='50px'/></Tooltip>
                    <Tooltip title='css3'><img className='img-scale' alt="" src="https://icongr.am/devicon/css3-original.svg?size=128&color=currentColor" width='50px'/></Tooltip>
                
                    <Tooltip title='bitbucket'><img className='img-scale' alt="" src="https://icongr.am/devicon/bitbucket-original-wordmark.svg?size=128&color=currentColor" width='50px'/></Tooltip>
                    <Tooltip title='redux'><img className='img-scale' alt="" src="./redux-icon.png" width='50px'/></Tooltip>
                    <Tooltip title='material ui'><img className='img-scale' alt="" src="./mui.png" width='50px'/></Tooltip>
                    <Tooltip title='chakra ui'><img className='img-scale' alt="" src="./chakra-ui.png" width='50px'/></Tooltip>
                    <Tooltip title='jwt'><img className='img-scale' alt="" src="./jwt-3.svg" width='50px'/></Tooltip>
                    <Tooltip title='netlify'><img className='img-scale' alt="" src="./netlify-icon.png" width='50px'/></Tooltip>
                    <Tooltip title='render'><img className='img-scale' alt="" src="./render.png" width='50px'/></Tooltip>
                    <Tooltip title='git'><img className='img-scale' alt="" src="./Git-Icon.png" width='50px'/></Tooltip>
                    <Tooltip title='power bi'><img className='img-scale' alt="" src="./power-bi.png" width='50px'/></Tooltip>
                </div>
                {!mediaMatch && <br/>}
                <div style={{
                    fontSize:mediaMatch?24:18,
                    lineHeight:2,
                    borderLeft:mediaMatch?'1px solid grey':'',
                    paddingLeft:mediaMatch?10:0,
                    display:"flex",
                    flexDirection: "column",
                    gap: "0.6em",
                    marginTop: !mediaMatch? "2em":"0em"
                }}>
                    <div className='skill-badge'> Critical Thinking </div>
                    <div className='skill-badge'> Presentation Skills </div>
                    <div className='skill-badge'> Brainstorming</div>
                    <div className='skill-badge'> Solving Problems  </div>
                    <div className='skill-badge'> Teaching skills </div>
                </div>
            </div>
        </div>
    )
}

export default Skills;